import script from "./Welcome16167.vue?vue&type=script&setup=true&lang=ts"
export * from "./Welcome16167.vue?vue&type=script&setup=true&lang=ts"

import "./Welcome16167.vue?vue&type=style&index=0&id=430b1df4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-430b1df4"]])

export default __exports__